import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { EntgeltatlasService } from '../../../../services/detailseite/entgeltatlas.service';
import { Observable } from 'rxjs';
import { BildungsangebotTerminDetail } from '../../../../model';
import { Kosten } from '../../../../model/kosten';
import { DauerTermineComponent } from '../detail-inhalt/dauer-termine/dauer-termine.component';
import { KostenGebuehrenComponent } from '../detail-inhalt/kosten-gebuehren/kosten-gebuehren.component';
import { VeranstaltungsortComponent } from '../detail-inhalt/veranstaltungsort/veranstaltungsort.component';
import { VerdienstComponent } from '../detail-inhalt/verdienst/verdienst.component';
import { DetailKachelComponent } from '../detail-kachel/detail-kachel.component';

@Component({
  selector: 'now-wbsuche-lib-tab-daten-fakten',
  templateUrl: './tab-daten-fakten.component.html',
  imports: [
    DetailKachelComponent,
    DauerTermineComponent,
    VeranstaltungsortComponent,
    KostenGebuehrenComponent,
    VerdienstComponent,
    AsyncPipe
  ]
})
export class TabDatenFaktenComponent implements OnInit {
  private readonly entgeltatlasService = inject(EntgeltatlasService);

  @Input()
  public termin!: BildungsangebotTerminDetail;

  public collapseStates: {
    veranstaltungsort?: boolean;
    verdienstaussichten?: boolean;
  } = {};

  public medianBausteine$!: Observable<string[]>;

  ngOnInit(): void {
    this.medianBausteine$ = this.entgeltatlasService.getMedianBausteine$(this.termin.angebot);
  }

  protected readonly Kosten = Kosten;
}
